// extracted by mini-css-extract-plugin
module.exports = {"Team":"Team_Team__MRa3K","list":"Team_list__z8_xC","item":"Team_item__nzEJy","paragraph":"Team_paragraph__9n5RA","column":"Team_column__ky_5A"};